<template>
  <div class="app-container">
    <div class="availability-banner" role="status" aria-live="polite">
      <span class="ab-text">
        本日 <strong>{{ nowLabel }}</strong><br class="sp-br" />
        今なら最短でご案内可能！
      </span>
    </div>

    <div class="titled-box-container-rank1">
      <h2 class="titled-box-header">
        <br />
        <span><i>No.1</i></span>
        お湯が出ない.com
      </h2>
      <div class="titled-box-content">
        <RatingBarRank111 />
        <div class="vendor-img">
          <img src="../../assets/rank-table/vendor-4-1.png" alt="" />
        </div>
        <InfoGridRank111 />
        <ButtonRank111 />
        <RecommendPointRank111 />
        <ReviewsContentRank111 />
        <ButtonRank111 />
      </div>
    </div>

    <div class="titled-box-container-rank2">
      <h2 class="titled-box-header">
        <br />
        <span><i>No.2</i></span>
        給湯器駆けつけ隊
      </h2>
      <div class="titled-box-content">
        <RatingBarRank112 />
        <div class="vendor-img">
          <img src="../../assets/rank-table/vendor-1.png" alt="" />
        </div>
        <InfoGridRank112 />
        <RecommendPointRank112 />
        <ButtonRank112 />
      </div>
    </div>

    <div class="titled-box-container-rank3">
      <h2 class="titled-box-header">
        <br />
        <span><i>No.3</i></span>
        チカラもち
      </h2>
      <div class="titled-box-content">
        <RatingBarRank113 />
        <div class="vendor-img">
          <img src="../../assets/rank-table/vendor-6.png" alt="" />
        </div>
        <InfoGridRank113 />
        <RecommendPointRank3 />
        <ReviewsContentRank2 />
        <br>
        <ButtonRank3 />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

import InfoGridRank112 from './InfoGridRank112.vue';
import InfoGridRank111 from './InfoGridRank11-1.vue';
import InfoGridRank113 from './InfoGridRank113.vue';
import RatingBarRank111 from './RatingBarRank11-1.vue';
import RatingBarRank112 from './RatingBarRank11-2.vue';
import RatingBarRank113 from './RatingBarRank113.vue';
import ReviewsContentRank111 from './ReviewsContentRank111'
// import RatingBarRank3 from './RatingBarRank3.vue';
import RecommendPointRank112 from './RecommendPointRank112.vue';
import RecommendPointRank111 from './RecommendPointRank111.vue';
import RecommendPointRank3 from './RecommendPointRank3.vue';
// import RecommendPointRank3 from './RecommendPointRank3.vue';
// import ReviewsContentRank2 from './ReviewsContentRank2.vue';
// import ReviewsContentRank3 from './ReviewsContentRank3.vue';
import ButtonRank112 from './ButtonRank112.vue';
// import ButtonRank101 from './ButtonRank101.vue';
import ButtonRank111 from './ButtonRank111.vue';
import ButtonRank3 from './ButtonRank3.vue';
// import ButtonRank3 from './ButtonRank3.vue';

const nowLabel = ref('');
let timerId;

const pad = (n) => String(n).padStart(2, '0');
const updateNow = () => {
  const d = new Date();
  nowLabel.value = `${d.getMonth() + 1}月${d.getDate()}日${pad(d.getHours())}時${pad(d.getMinutes())}分`;
};

onMounted(() => {
  updateNow();
  timerId = setInterval(updateNow, 1000);
});
onBeforeUnmount(() => {
  if (timerId) clearInterval(timerId);
});
</script>

<style scoped>
.app-container {
  background: #eef5ff;
  padding-bottom: 30px;
}

.availability-banner {
  position: relative;
  margin: 14px 10px 0;
  padding: 30px;
  background: #d9534f;
  color: #fff;
  font-weight: 800;
  text-align: center;
  margin-top: 0;
}

.availability-banner::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -16px;
  width: 0;
  height: 0;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid #d9534f;
  filter: drop-shadow(0 2px 0 rgba(0, 0, 0, .08));
  /* animation: abArrowFloat 1.4s ease-in-out infinite; */
}

@keyframes abArrowFloat {
  0%   { bottom: -16px; }
  50%  { bottom: -10px; }
  100% { bottom: -16px; }
}

@media (prefers-reduced-motion: reduce) {
  .availability-banner::after {
    animation: none;
  }
}

.ab-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  translate: 0 -50%;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: #fff;
  color: #ff7a00;
  border-radius: 50%;
  font-size: 16px;
  font-weight: 900;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
}

.ab-text {
  display: inline-block;
  line-height: 1.35;
  font-size: clamp(16px, 2.8vw, 20px);
}

.ab-text strong {
  font-size: clamp(18px, 3.2vw, 22px);
  text-decoration: underline;
  text-underline-offset: 3px;
  color: #f3d67f;
}

.titled-box-container-rank1,
.titled-box-container-rank2,
.titled-box-container-rank3 {
  margin-top: 0;
  overflow: hidden;
}

.titled-box-container-rank1 .titled-box-header,
.titled-box-container-rank2 .titled-box-header,
.titled-box-container-rank3 .titled-box-header {
  background-color: #3f51b5;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 900;
  font-size: 35px;
  margin-right: 10px;
  margin-left: 10px;
  border-radius: 10px 10px 0 0;
}

.titled-box-container-rank1 .titled-box-content,
.titled-box-container-rank2 .titled-box-content,
.titled-box-container-rank3 .titled-box-content {
  background-color: white;
  margin: 10px;
  margin-top: 0;
  border: 1px solid gray;
  border-radius: 0 0 10px 10px;
}

.vendor-img img {
  width: 95%;
}

.titled-box-header {
  position: relative;
  padding: 1rem 2rem 1rem 4em;
  margin-bottom: 0;
}

.titled-box-header span {
  position: absolute;
  top: -10px;
  left: 20px;
  display: inline-block;
  width: 70px;
  height: 50px;
  text-align: center;
}

.titled-box-header span i {
  position: relative;
  top: 35%;
  z-index: 1;
  width: 100%;
  font-size: 25px;
  font-style: normal;
  font-weight: 900;
  color: #fff;
  text-shadow:
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000;
}

.titled-box-container-rank1 .titled-box-header span {
  background: #ffc107;
}

.titled-box-container-rank1 .titled-box-header span:before {
  content: '';
  position: absolute;
  right: -10px;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #ffc107;
}

.titled-box-container-rank1 .titled-box-header span:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  display: block;
  height: 50%;
  border: 1em solid #ffc107;
  border-bottom-width: 15px;
  border-bottom-color: transparent;
}

.titled-box-container-rank2 .titled-box-header span {
  background: #aba4a4;
}

.titled-box-container-rank2 .titled-box-header span:before {
  content: '';
  position: absolute;
  right: -10px;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #aba4a4;
}

.titled-box-container-rank2 .titled-box-header span:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  display: block;
  height: 50%;
  border: 1em solid #aba4a4;
  border-bottom-width: 15px;
  border-bottom-color: transparent;
}

.titled-box-container-rank3 .titled-box-header span {
  background: #a0522d;
}

.titled-box-container-rank3 .titled-box-header span:before {
  content: '';
  position: absolute;
  right: -10px;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #a0522d;
}

.titled-box-container-rank3 .titled-box-header span:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  display: block;
  height: 50%;
  border: 1em solid #a0522d;
  border-bottom-width: 15px;
  border-bottom-color: transparent;
}

@media (max-width: 600px) {
  .sp-br {
    display: inline;
  }

  .availability-banner {
    padding: 20px;
    margin: 15px 13px 15px;
    margin-top: 0;
  }

  .ab-icon {
    left: 14px;
    width: 26px;
    height: 26px;
    font-size: 14px;
  }

  .ab-text {
    font-size: 1.2rem;
  }

  .ab-text strong {
    font-size: 1.5rem;
  }

  .titled-box-container-rank1 .titled-box-header,
  .titled-box-container-rank2 .titled-box-header,
  .titled-box-container-rank3 .titled-box-header {
    font-size: 25px;
  }

  .titled-box-header span {
    width: 60px;
  }

  .titled-box-header span i {
    font-size: 1.3rem;
  }

  .titled-box-container-rank1 .titled-box-header span:after {
    top: 30%;
    border: 1.2em solid #ffc107;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
  }

  .titled-box-container-rank2 .titled-box-header span:after {
    top: 30%;
    border: 1.2em solid #aba4a4;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
  }

  .titled-box-container-rank3 .titled-box-header span:after {
    top: 30%;
    border: 1.2em solid #a0522d;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
  }
}

@media (max-width: 480px) {
  .titled-box-container-rank1 .titled-box-content,
  .titled-box-container-rank2 .titled-box-content,
  .titled-box-container-rank3 .titled-box-content {
    margin-left: 10px;
    margin-right: 10px;
  }

  .titled-box-container-rank1 .titled-box-header,
  .titled-box-container-rank2 .titled-box-header,
  .titled-box-container-rank3 .titled-box-header {
    font-size: 20px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .titled-box-header span {
    width: 50px;
  }

  .titled-box-header span i {
    font-size: 1.1rem;
  }

  .titled-box-container-rank1 .titled-box-header span:after {
    top: 30%;
    border: 1.25em solid #ffc107;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
  }

  .titled-box-container-rank2 .titled-box-header span:after {
    top: 30%;
    border: 1.25em solid #aba4a4;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
  }

  .titled-box-container-rank3 .titled-box-header span:after {
    top: 30%;
    border: 1.25em solid #a0522d;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
  }
}
</style>
